// Consolidated blog posts → pillar guides.
// Keys are legacy /blog/<slug> paths; values are the pillar slug they now point to.

const LIFE_COACHING_SOURCES = [
  "one-on-one-life-coaching-sessions-corporate-training",
  "life-coaching-for-decision-making",
  "life-coaching-for-career-transitions",
  "life-coaching-for-stress-management",
  "icf-aligned-life-coach-india-corporate-training",
  "life-coaching-for-burnout-recovery",
  "life-coaching-for-career-clarity",
  "life-coaching-sessions-online-india",
  "life-coaching-for-mid-career-professionals",
  "life-coaching-benefits-for-professionals",
  "life-coaching-for-leadership-development",
  "certified-life-coach-near-me",
  "life-coaching-for-managers",
  "what-does-a-life-coach-do",
  "life-coaching-for-self-confidence-corporate-training",
  "life-coaching-for-women-professionals",
  "how-life-coaching-helps-career-growth",
  "life-coach-for-personal-growth",
  "life-coach-abu-dhabi-corporate-training",
  "life-coaching-for-it-professionals",
  "life-coaching-vs-therapy",
  "personal-coaching-for-career-growth",
  "best-life-coach-in-bangalore",
  "life-coaching-for-entrepreneurs",
  "best-life-coach-in-uae",
  "life-coach-for-working-professionals",
  "clarity-coaching-for-professionals",
  "transformational-life-coaching-corporate-training",
  "life-coaching-services-india-corporate-training",
  "life-coaching-for-overwhelmed-professionals",
  "how-to-find-a-life-coach",
] as const;

const COMMUNICATION_SOURCES = [
  "professional-communication-skills-workshop",
  "communication-skills-training-for-employees",
  "communication-skills-for-leaders",
  "how-to-improve-communication-skills-at-work",
  "dialogue-based-corporate-training",
  "active-listening-training-for-teams",
  "team-communication-workshop",
  "strategic-communication-training-for-leaders",
  "communication-gap-in-the-workplace",
  "stakeholder-management-training",
  "active-listening-skills-workshop",
  "communication-training-for-it-professionals",
  "empathy-training-in-the-workplace",
  "communication-skills-workshop-for-corporates",
  "how-to-communicate-effectively-with-stakeholders",
  "business-communication-training-for-corporates",
  "adaptive-communication-styles-training",
  "how-to-bridge-communication-gaps-in-teams",
  "assertive-communication-training",
  "interpersonal-skills-training-for-professionals",
  "influence-and-persuasion-training",
  "corporate-communication-training",
  "strategic-communication-training",
  "cross-cultural-communication-training",
  "empathetic-communication-training",
  "executive-communication-coaching",
  "communication-skills-for-remote-teams",
] as const;

const CAMPUS_SOURCES = [
  "campus-to-corporate-training-for-students",
  "career-readiness-program-for-colleges",
  "campus-placement-soft-skills-training",
  "how-to-transition-from-campus-to-corporate",
  "employability-skills-training-for-students",
  "graduate-employability-skills",
  "problem-solving-training-for-students",
  "corporate-readiness-training-for-graduates",
  "campus-to-corporate-training",
  "time-management-training-for-students",
  "interview-readiness-training-for-students",
  "corporate-communication-training-for-freshers",
  "confidence-building-workshop-for-students",
  "professional-etiquette-for-fresh-graduates",
  "how-to-build-workplace-confidence-as-a-fresher",
  "corporate-etiquette-workshop-for-students",
  "campus-to-corporate-gap",
  "placement-training-for-engineering-students",
  "how-to-prepare-students-for-corporate-life",
  "workplace-behaviour-training-for-freshers",
  "career-preparedness-workshop",
] as const;

const LEADERSHIP_SOURCES = [
  "leadership-development-for-middle-management",
  "authentic-leadership-training-what-it-really-means",
  "high-performance-team-leadership-training",
  "decision-making-training-for-leaders",
  "leadership-development-programs-india",
  "strategic-leadership-workshop-for-senior-management",
  "leadership-development-for-it-professionals",
  "leadership-skills-for-first-time-managers",
  "leadership-identity-coaching-what-it-is-and-why-you-need-it",
  "leading-through-change-training",
  "decision-making-training-for-students",
  "how-to-build-leadership-skills-in-the-workplace",
  "decision-making-under-pressure-training",
  "leadership-training-for-cxos",
  "leadership-facilitation-services-what-they-really-are",
  "leadership-offsite-facilitator",
  "change-management-training-for-leaders",
  "leadership-coaching-for-entrepreneurs",
  "how-to-lead-through-uncertainty",
  "leadership-training-for-senior-leaders",
] as const;

const BRANDING_SOURCES = [
  "confidence-through-personal-branding",
  "personal-brand-building-workshop",
  "executive-image-consulting",
  "first-impression-training-for-professionals",
  "personal-brand-strategy-for-career-growth",
  "authentic-personal-branding-coaching-corporate-training",
  "how-to-improve-personal-brand-as-a-professional",
  "colour-analysis-for-personal-branding",
  "personal-branding-through-image-consulting",
  "wardrobe-styling-for-professionals",
  "capsule-wardrobe-coaching-corporate-training",
  "personal-branding-for-leaders",
  "how-to-build-a-personal-brand-at-work",
  "personal-branding-for-corporate-professionals",
  "image-consulting-services-uae-corporate-training",
  "image-consulting-services-india",
  "personal-branding-workshop-for-professionals",
  "personal-branding-coach",
  "leadership-branding-workshop-what-it-is-and-why-you-need-one",
] as const;

const WELLBEING_SOURCES = [
  "emotional-wellness-workshops-for-employees",
  "mental-strength-building-for-professionals",
  "work-life-integration-coaching",
  "resilience-training-for-employees",
  "resilience-workshop-for-teams",
  "how-to-build-resilience-in-the-workplace",
  "mental-health-training-for-corporates",
  "resilience-coaching-for-professionals",
  "employee-well-being-programs-that-actually-work",
  "work-life-balance-coaching",
  "wellbeing-programs-for-corporate-teams",
  "mental-fitness-training-for-professionals",
  "corporate-wellness-training-programs",
] as const;


const STRESS_SOURCES = [
  "how-to-manage-performance-pressure-at-work",
  "stress-management-workshop",
  "stress-management-through-colours-and-art",
  "work-related-stress-management-techniques",
  "creative-stress-management-workshops",
  "how-to-manage-stress-at-work",
  "stress-management-training-for-employees",
  "art-therapy-for-stress-in-workplace",
  "stress-management-training-for-it-professionals",
  "stress-management-through-art-therapy",
  "stress-resilience-training-programs",
  "workplace-stress-management-strategies",
] as const;

const CORPORATE_TRAINING_SOURCES = [
  "sustainable-productivity-coaching-corporate-training",
  "personal-development-coaching-corporate-training",
  "in-person-corporate-training-workshops",
  "professional-development-training-for-employees",
  "corporate-behavioural-training-programs",
  "professional-etiquette-training-for-employees",
  "reflective-learning-in-corporate-training",
  "corporate-training-programs-india-what-works-what-doesnt",
  "workplace-behaviour-training-what-actually-works",
  "experiential-learning-workshops-for-corporates",
] as const;

const SPEAKING_SOURCES = [
  "business-presentation-skills-course",
  "public-speaking-training-for-students",
  "public-speaking-training-professionals",
  "how-to-give-an-elevator-pitch",
  "presentation-skills-training-for-students",
  "business-writing-skills-for-students",
  "elevator-pitch-training",
  "presentation-skills-training-for-professionals",
  "business-writing-training-for-employees",
] as const;

const BURNOUT_SOURCES = [
  "burnout-recovery-coaching-corporate-teams",
  "how-to-deal-with-burnout-at-work",
  "how-to-reduce-employee-burnout",
  "employee-burnout-signs-and-solutions",
  "burnout-coaching-for-managers",
  "burnout-prevention-training-for-corporates",
] as const;

const PRESENCE_SOURCES = [
  "executive-presence-training-what-it-really-means",
  "executive-presence-training-for-women",
  "how-to-develop-executive-presence",
  "what-is-executive-presence-and-why-it-matters",
  "leadership-presence-workshop",
] as const;

const CAREER_CLARITY_SOURCES = [
  "how-to-overcome-career-confusion",
  "career-direction-coaching",
  "career-mindset-training-for-students",
  "career-clarity-coaching",
  "coaching-for-career-stuck-professionals",
] as const;

const BODY_LANGUAGE_SOURCES = [
  "body-language-coaching-for-executives",
  "body-language-coaching-corporate-training",
  "body-language-training-for-professionals",
  "non-verbal-communication-training",
  "how-to-improve-body-language-at-work",
] as const;

const DIFFICULT_CONVERSATIONS_SOURCES = [
  "difficult-conversations-training-for-managers",
  "conflict-resolution-training-for-teams",
  "how-to-have-difficult-conversations-at-work",
  "conflict-resolution-workshop-for-employees",
] as const;

export const LIFE_COACHING_PILLAR = "life-coaching-guide";
export const COMMUNICATION_PILLAR = "communication-skills-training-guide";
export const CAMPUS_PILLAR = "campus-to-corporate-guide";
export const LEADERSHIP_PILLAR = "leadership-development-guide";
export const BRANDING_PILLAR = "personal-branding-image-consulting-guide";
export const WELLBEING_PILLAR = "workplace-wellbeing-resilience-guide";
export const STRESS_PILLAR = "stress-management-training-guide";
export const CORPORATE_TRAINING_PILLAR = "corporate-training-programs-guide";
export const SPEAKING_PILLAR = "public-speaking-presentation-skills-guide";
export const BURNOUT_PILLAR = "burnout-recovery-prevention-guide";
export const PRESENCE_PILLAR = "executive-presence-guide";
export const CAREER_CLARITY_PILLAR = "career-clarity-coaching-guide";
export const BODY_LANGUAGE_PILLAR = "body-language-training-guide";
export const DIFFICULT_CONVERSATIONS_PILLAR = "difficult-conversations-conflict-resolution-guide";


export const BLOG_REDIRECT_MAP: Record<string, string> = {
  ...Object.fromEntries(LIFE_COACHING_SOURCES.map((slug) => [slug, LIFE_COACHING_PILLAR])),
  ...Object.fromEntries(COMMUNICATION_SOURCES.map((slug) => [slug, COMMUNICATION_PILLAR])),
  ...Object.fromEntries(CAMPUS_SOURCES.map((slug) => [slug, CAMPUS_PILLAR])),
  ...Object.fromEntries(LEADERSHIP_SOURCES.map((slug) => [slug, LEADERSHIP_PILLAR])),
  ...Object.fromEntries(BRANDING_SOURCES.map((slug) => [slug, BRANDING_PILLAR])),
  ...Object.fromEntries(WELLBEING_SOURCES.map((slug) => [slug, WELLBEING_PILLAR])),
  ...Object.fromEntries(STRESS_SOURCES.map((slug) => [slug, STRESS_PILLAR])),
  ...Object.fromEntries(CORPORATE_TRAINING_SOURCES.map((slug) => [slug, CORPORATE_TRAINING_PILLAR])),
  ...Object.fromEntries(SPEAKING_SOURCES.map((slug) => [slug, SPEAKING_PILLAR])),
  ...Object.fromEntries(BURNOUT_SOURCES.map((slug) => [slug, BURNOUT_PILLAR])),
  ...Object.fromEntries(PRESENCE_SOURCES.map((slug) => [slug, PRESENCE_PILLAR])),
  ...Object.fromEntries(CAREER_CLARITY_SOURCES.map((slug) => [slug, CAREER_CLARITY_PILLAR])),
  ...Object.fromEntries(BODY_LANGUAGE_SOURCES.map((slug) => [slug, BODY_LANGUAGE_PILLAR])),
  ...Object.fromEntries(DIFFICULT_CONVERSATIONS_SOURCES.map((slug) => [slug, DIFFICULT_CONVERSATIONS_PILLAR])),

  // Pre-existing consolidation
  "face-to-face-soft-skills-training": "soft-skills-training-for-corporates",
};


export const getBlogRedirectTarget = (slug?: string): string | null => {
  if (!slug) return null;
  return BLOG_REDIRECT_MAP[slug.toLowerCase()] ?? null;
};
